<template>
  <div class="BS-slide view-slide">
    <img src="../../assets/images/boundary-selector.png" />
    <div class="slide-text-part">
      <!-- <h3>Boundary Selector</h3> -->
      <img src="../../assets/images/boundary-selector-logo.svg"  v-on:click="select($event)">
     
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>Geographical application that provides selection for Countries, States, Counties and Fields. Through different zoom levels it loads the suitable layer  </p>
      <div class="text-center">
        <button v-on:click="select($event)">OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "BoundrySelectorComponent"
};
</script>

